import { type ILayoutConfig } from '@/providers/LayoutProvider';

// Defining the configuration for the branded authentication layout
const authLayoutBrandedConfig: ILayoutConfig = {
  // Setting the layout name to 'auth-branded'
  name: 'auth-branded',

  // Currently no additional options defined, but this object can be extended in the future
  options: {}
};

export { authLayoutBrandedConfig };
